import { IOfferModeWithFSecure } from "@nju/data-access-portal-offers";
import { IOrchestrators } from "../fetchOrchestrators";

export function getOrchestratorForMode(
  orchestrators: IOrchestrators,
  mode: IOfferModeWithFSecure,
) {
  if (mode === "ftth") {
    return orchestrators.ftth;
  }

  if (mode === "mobile" || mode === "postpaid") {
    return orchestrators.multiOrder;
  }

  if (mode === "fsecure") {
    return orchestrators.fsecure;
  }

  throw new Error("Unknown mode");
}
